export default __webpack_public_path__ + "static/media/users.210e3381.svg";